import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { TextValueItem } from "@/models/TextValueItem";
import api from "@/services/api";
import permessi from "@/config/permessi";
import { TipiValoreSchedaParametri } from "@/models/amministrazione/parametri/TipiValoreSchedaParametri";

const _ENDPONT = api.endpoint.AMMINISTRAZIONE.TIPI_PARAMETRI_VALORI;
@Component({})
export default class TipiParametriValori extends gridComponentBase {
	get PERMESSI(): string[] { return [permessi.BK.Amministrazione.TIPI_PARAMETRI]; }
	@Prop({ default: () => null }) itemID: number;
	editItem: TipiValoreSchedaParametri = new TipiValoreSchedaParametri();
	showEditModal: boolean = false;
	editSubTitle: string = "";
	editTitle: string = "";
	kendop: any = kendo;

	showOnlyActive: boolean = false;

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, headerCell: "myHeaderCellTemplate", editHide: true },
			{ field: "valore", title: this.$i18n.t("generico.valore").toString(),  headerCell: "myHeaderCellTemplate"},
			{ field: "descrizione", title: this.$i18n.t("generico.descrizione").toString(),  headerCell: "myHeaderCellTemplate"},
		
			{ field: "_actions", title: " ", width: (50 + (this.canDelete ? 50 : 0)), cell: "defaultCellTemplate", type: "actions_list", filterable: false, headerCell: "myHeaderCellTemplate" }
		];
	}

	sort: any = [{ field: "valore", dir: "asc" }];

	created() {
		var self = this;
		this.take = 60;
		this.pageable.pageSize = 60;
		this.pageSize = 60;
		if (this.group) {
			this.group.map(group => (group.aggregates = this.aggregates));
		}
		this.group = this.group;

		Promise.all([])
			.then(responses => {
				self.getData();
			})
			.catch(err => {
				console.log(err);
			});
	}

	getData() {
		this.getGridData(`${_ENDPONT}/${this.itemID}`);
	}

	onDelete(item: any) {
		var self = this;
		var message = self.$createElement("div", { domProps: { innerHTML: `<h5>${item.itemID}</h5>${self.$i18n.t("messaggio.confermaCancellazione")}` } }); 
		var title = this.$i18n.t("titolo.elimina", [this.$i18n.t("generico.valoreTipoParametro")]).toString();
		self.deleteGridRow(_ENDPONT, item.itemID, title, [message]);
	}

	addNewRow() {
		let newItem = new TipiValoreSchedaParametri();
		if (this.itemsGrid.length) {
			var values = this.itemsGrid.map(function(x: TipiValoreSchedaParametri) {
				return x.valore;
			});
			
			var maxValue = Math.max.apply(Math, values);
			console.log(maxValue);
			newItem.valore = maxValue + 1;

			newItem.overIns_TipoSchedaParametri_TypeId = this.itemID;
		}
		else {
			newItem.valore = 1;
			newItem.overIns_TipoSchedaParametri_TypeId = this.itemID;
		}

		this.onEdit(newItem);
	}

	onEdit(item: any) {
		var self = this;
		self.editItem = Object.assign(new TipiValoreSchedaParametri(), item);
		self.editSubTitle = "";
		self.editTitle = item.itemID;
		self.showEditModal = true;
	}

	onSaveEdit() {
		var self = this;
		var title = this.$i18n.t("msg.salvataggioRiuscito").toString();
		var message = this.$i18n.tc("msg.salvato_iCorrettamente", 1, { obj: this.$i18n.t("generico.valoreTipoParametro") }).toString();
		self.setGridRow<TipiValoreSchedaParametri>(_ENDPONT, self.editItem, title, message, self.isNewItem).then(res => {
			self.showEditModal = false;
		});
	}

	get isNewItem(): boolean {
		return (this.editItem || {}).itemID == null || (this.editItem || {}).itemID <= 0;
	}
}
